/*
 * Weather glyphs — ONE definition, used by /weather and by the profile widget.
 *
 * These lived twice: once in weather.js and once in profile-weather.js. The
 * widget copy carried the markup but not the stylesheet, so `.wx-ic` had no
 * `fill: none`, no stroke and no size — and the profile page rendered a black
 * cloud the height of the whole card. Nothing in either file looked wrong on
 * its own; the bug only existed in the gap between them. So the paths, the
 * symbol→glyph mapping AND the stylesheet now ship together and cannot drift.
 *
 * Pairs with partials/weather-icon-css.blade.php — include that wherever this
 * script is loaded.
 *
 * window.WeatherIcons = { paths, iconFor(symbolCode), svg(key, extraClass) }
 */
(function () {
'use strict';

var PATHS = {
    'sun':        '<circle cx="12" cy="12" r="4.6"/><g class="ray"><path d="M12 2.4v2.6M12 19v2.6M2.4 12h2.6M19 12h2.6M5.2 5.2l1.9 1.9M16.9 16.9l1.9 1.9M18.8 5.2l-1.9 1.9M7.1 16.9l-1.9 1.9"/></g>',
    'moon':       '<path d="M20 14.4A8.5 8.5 0 019.6 4 7.6 7.6 0 1020 14.4z"/>',
    'sun-cloud':  '<circle class="sm" cx="8.6" cy="8.4" r="3.3"/><path class="ray" d="M8.6 2.6v1.8M2.8 8.4h1.8M4.5 4.3l1.3 1.3M12.7 4.3l-1.3 1.3"/><path class="cl" d="M8.4 19.4h8.9a3.4 3.4 0 00.3-6.8 4.7 4.7 0 00-9-1.2 3.5 3.5 0 00-.2 8z"/>',
    'moon-cloud': '<path class="sm" d="M14.6 9.4A5.2 5.2 0 018.2 3a4.7 4.7 0 106.4 6.4z"/><path class="cl" d="M8.4 19.9h8.9a3.4 3.4 0 00.3-6.8 4.7 4.7 0 00-9-1.2 3.5 3.5 0 00-.2 8z"/>',
    'cloud':      '<path class="cl" d="M7.4 19h9.9a3.8 3.8 0 00.3-7.6 5.2 5.2 0 00-10-1.3A3.9 3.9 0 007.4 19z"/>',
    'fog':        '<path class="cl" d="M7.4 14.4h9.9a3.8 3.8 0 00.3-7.6 5.2 5.2 0 00-10-1.3 3.9 3.9 0 00-.2 8.9z"/><path d="M4 18h16M6.5 21h11"/>',
    'rain':       '<path class="cl" d="M7.4 15.2h9.9a3.8 3.8 0 00.3-7.6 5.2 5.2 0 00-10-1.3 3.9 3.9 0 00-.2 8.9z"/><path class="dr" d="M9.4 18l-1 2.9M14.6 18l-1 2.9"/>',
    'rain-heavy': '<path class="cl" d="M7.4 14.6h9.9a3.8 3.8 0 00.3-7.6 5.2 5.2 0 00-10-1.3 3.9 3.9 0 00-.2 8.9z"/><path class="dr" d="M8 17.4l-1.2 3.4M12 17.4l-1.2 3.4M16 17.4l-1.2 3.4"/>',
    'sleet':      '<path class="cl" d="M7.4 14.6h9.9a3.8 3.8 0 00.3-7.6 5.2 5.2 0 00-10-1.3 3.9 3.9 0 00-.2 8.9z"/><path class="dr" d="M9.2 17.6l-1.1 3.2"/><path class="sn" d="M14.4 18.4v2.8M13.2 19.1l2.4 1.4M15.6 19.1l-2.4 1.4"/>',
    'snow':       '<path class="cl" d="M7.4 14.6h9.9a3.8 3.8 0 00.3-7.6 5.2 5.2 0 00-10-1.3 3.9 3.9 0 00-.2 8.9z"/><path class="sn" d="M9 17.8v3M7.7 18.5l2.6 1.5M10.3 18.5l-2.6 1.5M15 17.8v3M13.7 18.5l2.6 1.5M16.3 18.5l-2.6 1.5"/>',
    'thunder':    '<path class="cl" d="M7.4 13.8h9.9a3.8 3.8 0 00.3-7.6 5.2 5.2 0 00-10-1.3 3.9 3.9 0 00-.2 8.9z"/><path class="bo" d="M13.2 15l-4 4.4h2.6l-1 3.4 4.2-4.8h-2.7z"/>'
};

/* MET publishes ~50 symbol codes (intensity × type × showers × thunder ×
   day/night). Collapse them onto the eleven shapes above. */
function iconFor(sym) {
    if (!sym) return 'cloud';
    var s = String(sym);
    var night = /_night$/.test(s);
    s = s.replace(/_(day|night|polartwilight)$/, '');
    if (/andthunder$/.test(s)) return 'thunder';
    s = s.replace(/andthunder$/, '').replace(/showers$/, '');
    if (s === 'clearsky') return night ? 'moon' : 'sun';
    if (s === 'fair' || s === 'partlycloudy') return night ? 'moon-cloud' : 'sun-cloud';
    if (s === 'cloudy') return 'cloud';
    if (s === 'fog') return 'fog';
    if (s.indexOf('snow') >= 0) return 'snow';
    if (s.indexOf('sleet') >= 0) return 'sleet';
    if (s.indexOf('rain') >= 0) return s.indexOf('heavy') === 0 ? 'rain-heavy' : 'rain';
    return 'cloud';
}

function svg(key, extraClass) {
    return '<svg class="wx-ic ' + (extraClass || '') + ' i-' + key + '" viewBox="0 0 24 24" aria-hidden="true">' +
           (PATHS[key] || PATHS.cloud) + '</svg>';
}

window.WeatherIcons = { paths: PATHS, iconFor: iconFor, svg: svg };

})();
